import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaHome, FaTicketAlt, FaTrophy, FaHandshake, FaUsers,
  FaChartLine, FaWallet, FaUser, FaCog, FaBell,
  FaRocket, FaShieldAlt, FaGift, FaHistory, FaStar,
  FaCompass, FaUserCheck, FaChartBar, FaCrown,
} from 'react-icons/fa';
import './MobileQuickPanel.css';

const QUICK_ACTIONS = [
  // Main navigation (mirrors the sidebar)
  { label: 'Virtual Comps',      icon: FaTrophy,        to: '/virtual-competitions', color: 'peach' },
  { label: 'Virtual H2H',        icon: FaUsers,         to: '/virtual-h2h',          color: 'mint' },
  { label: 'Explore',            icon: FaCompass,       to: '/explore',              color: 'coral' },
 { label: 'Rollover',           icon: FaChartLine,     to: '/rollover',             color: 'pale' },
  { label: 'Leaderboard',        icon: FaChartBar,      to: '/leaderboard',          color: 'tan' },
  
  // Account shortcuts (mirrors the drawer)
  { label: 'Wallet',             icon: FaWallet,        to: '/wallet',               color: 'yellow' },
  { label: 'Profile',            icon: FaUser,          to: '/profile',              color: 'cream' },
  { label: 'Notifications',      icon: FaBell,          to: '/notifications',        color: 'peach' },
  { label: 'Settings',           icon: FaCog,           to: '/settings',             color: 'grey' },
];

// Conditionally appended items
const EXTRA_ACTIONS = [
  { label: 'Creator Hub',        icon: FaRocket,        to: '/creator/dashboard',    color: 'pink',   requiresPunter: true },
  { label: 'Upgrade to Plus',    icon: FaCrown,         to: '/subscription',         color: 'orange', requiresNonPunter: true },
  { label: 'Admin Panel',        icon: FaShieldAlt,     to: '/admin',                color: 'coral',  requiresAdmin: true },
];

const MobileQuickPanel = ({ open, onClose, user, isAdmin, isPunterPlusActive }) => {
  if (!open) return null;

  const actions = [
    ...QUICK_ACTIONS,
    ...EXTRA_ACTIONS.filter(({ requiresPunter, requiresAuth, requiresNonPunter, requiresAdmin }) => {
      if (requiresAdmin && !isAdmin) return false;
      if (requiresPunter && !isPunterPlusActive) return false;
      if (requiresNonPunter && isPunterPlusActive) return false;
      if (requiresAuth && !user) return false;
      return true;
    }),
  ];

  return (
    <>
      <div className="quick-panel-backdrop" onClick={onClose} />

      <div className="quick-panel" role="dialog" aria-modal="true" aria-label="Quick actions">
        <div className="quick-panel-scroll">
          <div className="quick-panel-grid">
            {actions.map(({ label, icon: Icon, to, color }) => (
              <Link
                key={label}
                to={to}
                className="quick-action"
                onClick={onClose}
              >
                <span className={`quick-icon quick-icon-${color}`}>
                  <Icon />
                </span>
                <span className="quick-label">{label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileQuickPanel;